export default "__VITE_ASSET__iTaGcTft__"